import {FormHelperText, Stack} from "@mui/material";
import LocalizedTextField from "crqlar-react-common/dist/components/LocalizedTextField";
import Property from "crqlar-react-common/dist/components/Property";
import React from "react";
import {useTranslation} from "react-i18next";
import {languageName} from "../LanguageOption";
import {PAGE_LANGUAGES} from "./digitalSigningTemplate.model";
import {PageTexts, pageTexts} from "./digitalSigningTemplate.util";

// The page's languages, whatever the organization's are: the backend takes no others
const LANGUAGES: string[] = [...PAGE_LANGUAGES];

interface Props {
    id: string
    title: string
    tooltip: string
    value: PageTexts
    onChange: (value: PageTexts) => void
    errors?: Partial<PageTexts>
    multiline?: boolean
    disabled?: boolean
}

/** Localized text input row with language-specific validation errors. */
const DigitalSigningPageTextField = ({id, title, tooltip, value, onChange, errors, multiline, disabled}: Props) => {
    const {t} = useTranslation();

    return (
        <Property title={title} tooltip={tooltip} labelAlignment={'top'}>
            <Stack sx={{width: '100%', minWidth: 0}}>
                <LocalizedTextField
                    id={id}
                    size={'small'}
                    fullWidth
                    multiline={multiline}
                    rows={multiline ? 3 : undefined}
                    forceLanguages={LANGUAGES}
                    value={value}
                    onChange={texts => onChange(pageTexts(texts))}
                    disabled={disabled}
                />
                {PAGE_LANGUAGES.map(language => {
                    const error = errors?.[language];
                    return error ? (
                        <FormHelperText key={language} error sx={{mx: '14px'}}>
                            {`${languageName(language)}: ${t(error)}`}
                        </FormHelperText>
                    ) : null;
                })}
            </Stack>
        </Property>
    );
};

export default DigitalSigningPageTextField;
